import { inject, Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { firstValueFrom } from 'rxjs';
import { BasketItem } from '../models/basket.model';
import type { DialogRepeatableBookingData } from '../components/dialog-repeatable-booking/dialog-repeatable-booking.component';

@Injectable({ providedIn: 'root' })
export class BasketRepeatableService {
  private readonly dialog = inject(MatDialog);
  private opening = false;

  async open(basketItem: BasketItem, existingItems: BasketItem[]): Promise<BasketItem[]> {
    // The chunk load leaves a gap before the modal is up; a second click in it must not
    // open a second dialog that adds the same items again.
    if (this.opening) return [];
    this.opening = true;
    try {
      // Loaded on demand: the basket lives in the app shell, and a static import pulls
      // the dialog's datepicker, select, autocomplete and list into the initial bundle.
      // The load can fail (offline, or a chunk removed by a deploy since the page loaded);
      // the caller then gets no items rather than an unhandled rejection.
      let DialogRepeatableBookingComponent;
      try {
        ({ DialogRepeatableBookingComponent } = await import(
          '../components/dialog-repeatable-booking/dialog-repeatable-booking.component'
        ));
      } catch (error) {
        console.error('Could not load the repeat dialog', error);
        return [];
      }
      const data: DialogRepeatableBookingData = { basketItem, existingItems };
      const ref = this.dialog.open(DialogRepeatableBookingComponent, {
        data,
        width: '560px',
        maxHeight: '90vh',
        autoFocus: false,
      });
      const items: BasketItem[] | undefined = await firstValueFrom(ref.afterClosed());
      return items ?? [];
    } finally {
      this.opening = false;
    }
  }
}
